function App() {
  return (
    <div className="bg-gray-200 h-screen py-32">
      <div className="max-w-xl mx-auto bg-white h-[60vh] rounded-xl border border-[gray-200] shadow-lg">
        <div className="text-center justify-center flex flex-col">
          <img
            src="agrobiota-icon.png"
            className="h-64 w-64 mx-auto m-8 p-3"
            alt="Logo Agrobiota"
          />
          <p className="text-xl font-bold text-gray-500">
            O Agrobiota agora está de cara nova!
          </p>
          <a
            className="text-[#026B77] font-bold hover:underline my-5"
            href="https://portal.souagrobiota.com.br"
            rel="noopener noreferrer"
          >
            <h1 className="text-4xl my-2">Acesse Agora</h1>
            <div className="text-2xl">portal.souagrobiota.com.br</div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
